<nav class="navbar main-header navbar-expand-lg navbar-dark fixed-top" id="main-header">

  <ul class="navbar-left">
    <li class="brand">
      <img [src]="appLogo" class="logo" alt="logo" class="logo" />
    </li>
  </ul>
  <ul class="navbar-center">
    <li class="blue header-list-item cursor-default">
      <app-header-time-clock [isMilitaryTime]="isMilitaryTime" [date]="dates"></app-header-time-clock>
    </li>
  </ul>
  <ul class="navbar-right">
    <li class="mr-2">
      <div class="change-theme" (click)="changeTheme(!isDark)">
        @if(isDark){
        <svg class="svg-light-theme" fill="#ffc719" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="48px"
          height="48px">
          <title>Switch To Light Mode</title>
          <path
            d="M32 19c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13S24.82 19 32 19zM34 8c0 .366 0 5.634 0 6 0 1.105-.895 2-2 2s-2-.895-2-2c0-.366 0-5.634 0-6 0-1.105.895-2 2-2S34 6.895 34 8zM50.385 16.444c-.259.259-3.984 3.984-4.243 4.243-.781.781-2.047.781-2.828 0-.781-.781-.781-2.047 0-2.828.259-.259 3.984-3.984 4.243-4.243.781-.781 2.047-.781 2.828 0S51.166 15.663 50.385 16.444zM56 34c-.366 0-5.634 0-6 0-1.105 0-2-.895-2-2s.895-2 2-2c.366 0 5.634 0 6 0 1.105 0 2 .895 2 2S57.105 34 56 34zM47.556 50.385c-.259-.259-3.984-3.984-4.243-4.243-.781-.781-.781-2.047 0-2.828s2.047-.781 2.828 0c.259.259 3.984 3.984 4.243 4.243.781.781.781 2.047 0 2.828S48.337 51.166 47.556 50.385zM30 56c0-.366 0-5.634 0-6 0-1.105.895-2 2-2s2 .895 2 2c0 .366 0 5.634 0 6 0 1.105-.895 2-2 2S30 57.105 30 56zM13.615 47.556c.259-.259 3.984-3.984 4.243-4.243.781-.781 2.047-.781 2.828 0 .781.781.781 2.047 0 2.828-.259.259-3.984 3.984-4.243 4.243-.781.781-2.047.781-2.828 0S12.834 48.337 13.615 47.556zM8 30c.366 0 5.634 0 6 0 1.105 0 2 .895 2 2s-.895 2-2 2c-.366 0-5.634 0-6 0-1.105 0-2-.895-2-2S6.895 30 8 30zM16.444 13.615c.259.259 3.984 3.984 4.243 4.243.781.781.781 2.047 0 2.828-.781.781-2.047.781-2.828 0-.259-.259-3.984-3.984-4.243-4.243-.781-.781-.781-2.047 0-2.828S15.663 12.834 16.444 13.615z" />
        </svg>
        }@else{
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
          <title>Switch To Dark Mode</title>
          <path id="Moon"
            d="M24.86,15.53a.5.5,0,0,0-.57,0A10.71,10.71,0,0,1,9.57.79.5.5,0,0,0,9,0,12.77,12.77,0,1,0,25,16,.5.5,0,0,0,24.86,15.53Z"
            fill="#ffffff" />
        </svg>
        }
      </div>
    </li>
    <li>
      <search-header>          
      </search-header>
    </li>
    <li class="btn-group cursor-pointer" ngbDropdown>
      <img src="assets/images/user_role.svg" alt="" srcset="" class="user-icon" id="dropdownProfile" ngbDropdownToggle />
      <hw-header-profile ngbDropdownMenu aria-labelledby="dropdownProfile" class="dropdown-menu-end  right profile-caret">
      </hw-header-profile>
    </li>
  </ul>
</nav>